module.exports = __webpack_public_path__ + "img/shiseido_logo_white.8722bb51.svg";